<template>
  <div class="home">
      <el-row>
        <h1>Geopolítica - Locución 3º Año T. Noche</h1>
        <h2>Culturalismo</h2>
        <el-col :span="3" v-for="(o, index) in temas" :key="index">
          <el-card :body-style="{ padding: '0px' }">
            <!-- <img src="../assets/La_torre_de_Babel_Pieter_Brueghel.jpg"> -->
            <img :src="`${o.img_thumb}`" class="image" style="min-height: 160px;" @click="select(o)">
            <div style="padding: 14px;min-height: 100px;">
              <span>{{o.titulo}}</span>
              <!-- <div class="bottom clearfix">
                <time class="time">{{ currentDate }}</time>
                <el-button type="text" class="button">Operating button</el-button>
              </div> -->
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-dialog :title="selected.titulo" :visible.sync="dialogTableVisible" size="full">
        <video width="100%" height="100%" controls autoplay v-if="selected.video">
          <source :src="selected.video" type="video/mp4">
        </video>
        <img :style="{width: selected.width}" :src="selected.img" class="image" v-else>
        <p>{{selected.descripcion}}</p>
      </el-dialog>
      <el-row style="text-align: right;">
        <br>
        <br>
        <br>
        <br>
          <small>Design by Maru Amallo</small>
      </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentDate: new Date(),
      dialogTableVisible: false,
      selected: {},
      temas: [
        {
          titulo: 'La torre de Babel Pieter Brueghel',
          img_thumb: '/static/La_torre_de_Babel_Pieter_Brueghel.jpg',
          img: '/static/Portada-La-torre-de-Babel-Pieter-Brueghel.jpg',
          descripcion: 'Descripcion',
          width: '100%'
        },
        {
          titulo: 'PICASSO GUERNICA',
          img_thumb: '/static/PICASSO-GUERNICA.jpg',
          img: '/static/PICASSO-GUERNICA.jpg',
          descripcion: 'Descripcion',
          width: '100%'
        },
        {
          titulo: 'Calle 13 - Latinoamerica',
          img_thumb: '/static/calle_13-thumb.jpg',
          img: '/static/calle_13-thumb.jpg',
          video: '/static/Calle_13-Latinoamerica_HD_Con-letra-y-Subtitulado-al-español.mp4',
          descripcion: 'Descripcion',
          width: '100%'
        },
        {
          titulo: 'La secretaria de Hitler',
          img_thumb: '/static/lasecretariadehitler.jpg',
          img: '/static/lasecretariadehitler.jpg',
          video: '/static/La_secretaria_de_Hitler.mp4',
          descripcion: 'Descripcion',
          width: '100%'
        },
        {
          titulo: 'El comercio de esclavos - Biard, 1840',
          img_thumb: '/static/The_Slave_Trade_by_Auguste_Francois_Biard.jpg',
          img: '/static/The_Slave_Trade_by_Auguste_Francois_Biard.jpg',
          descripcion: 'Descripcion',
          width: '100%'
        },
        {
          titulo: 'MAHATMA GANDHI',
          img_thumb: '/static/gandhi-2.jpg',
          img: '/static/gandhi-2.jpg',
          descripcion: 'Descripcion',
          width: '100%'
        }
      ]
    };
  },
  methods: {
    select: function (item) {
      this.selected = item
      this.dialogTableVisible = true
    }
  }
}
</script>
<!-- Portada-La-torre-de-Babel-Pieter-Brueghel.jpg -->
<!-- La_torre_de_Babel_Pieter_Brueghel.jpg -->
<!-- PICASSO-GUERNICA.jpg -->
<!-- calle_13-thumb.jpg -->
<!-- Calle_13-Latinoamerica_HD_Con-letra-y-Subtitulado-al-español.mp4 -->
<!-- lasecretariadehitler.jpg -->
<!-- La_secretaria_de_Hitler.mp4 -->
<!-- The_Slave_Trade_by_Auguste_Francois_Biard.jpg -->
<!-- MAHATMA_GANDHI.jpg -->
<style>
  .time {
    font-size: 13px;
    color: #999;
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }

  .clearfix:after {
      clear: both
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue